class addonProduct {
    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} main
     */
    constructor(main) {

        const trigger = main.querySelector('[data-trigger]');

        this.dom = {
            main,
            trigger,
            text: main.querySelector('[data-trigger-text]')
        }
        this.settings = {
            id: trigger.dataset?.variantId ? Number(trigger.dataset.variantId) : null,
            limit: trigger.dataset?.limit ? Number(trigger.dataset.limit) : 0
        }
        this.text = {
            submit: trigger.dataset.textSubmit,
            submitted: trigger.dataset.textSubmitted
        }

        this.eventListeners();
    }

    click() {
        this.dom.trigger.classList.add('btn--loading');
        this.addToCart()
    }

    eventListeners() {
        this.dom.trigger.addEventListener('click', e => {
            this.click();
        })

        document.addEventListener('cart:updated', (e) => {
            /**
             * Only needs the items
             */
            const cartItems = { 'items': e.detail.cart.items }
            
            this.checkIfInCart(cartItems)
        })
    }

    /**
     * 
     * @param {object} cartItems 
     * 
     * This checks if the product is in the cart, and changes the text according toits state
     * 
     * Takes an object {items: [{'id': number, 'quantity', number },{'id': number, 'quantity', number }]}
     */
    checkIfInCart(cartItems) {

        if (cartItems != null) {
            const matches = cartItems.items.find(x => x.id === this.settings.id)

            if (this.settings.limit > 0) {
                this.handleItemWithLimit({ matches })
            } else if (this.dom.text) {
                const text = matches ? this.text.submitted : this.text.submit;
                this.dom.text.textContent = text;
            }
        } else {
            const isInCartDrawer = this.dom.trigger.classList.contains('in-cart-drawer');
            const text = isInCartDrawer ? this.text.submitted : this.text.submit;

            if (this.dom.text) {   
                this.dom.text.textContent = text;
            }
        }

        this.dom.trigger.classList.remove('btn--loading');
    }

    handleItemWithLimit({ matches }) {
        if (matches && matches.quantity >= this.settings.limit) {
            this.dom.main.style.display = "none"
        } else {
            this.dom.main.style.display = "block"
        }
    }


    addToCart() {
        
        const formData = { items: [{ 'id': this.settings.id, 'quantity': 1 }] };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {

                if (data.status == 422) {
                    alert(data.description)
                    throw new Error(data.description)
                }

                if (typeof updateCartItemsWindowArr === "function") {
                    updateCartItemsWindowArr(() => {document.dispatchEvent(new CustomEvent('cart:build'))});
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                
                this.checkIfInCart(null);
            });
    }
}

const addon_products = document.querySelectorAll('.js-addon-product')
addon_products.forEach(addon_product => {
    void new addonProduct(addon_product);
});